"use strict";

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@lsg/utils");

var React = __importStar(require("react"));

var WorldMap =
/** @class */
function (_super) {
  __extends(WorldMap, _super);

  function WorldMap(props) {
    var _this = _super.call(this, props) || this;

    _this.updateSize = function () {
      var numColumns = window.innerWidth < 800 && 1 || window.innerWidth < 1024 && 2 || 3;

      if (_this.state.numColumns !== numColumns) {
        _this.setState({
          numColumns: numColumns
        });
      }
    };

    _this.addEventListeners = function () {
      var numColumns = _this.state.numColumns;
      var targetArray = [];
      var elements = Array.from(_this.element.querySelectorAll(".countries [data-continent]"));
      elements.forEach(function (element, i) {
        var column = Math.floor(i * numColumns / elements.length);

        if (!targetArray[column]) {
          targetArray[column] = [];
        }

        targetArray[column].push(element);
      });

      var targetContainer = _this.element.querySelector(".listing");

      if (targetContainer) {
        targetContainer.innerHTML = "";
        targetArray.forEach(function (columnArray) {
          var columnElement = document.createElement("div");
          columnElement.classList.add("column");
          targetContainer.appendChild(columnElement);
          var ulElement = document.createElement("ul");
          columnElement.appendChild(ulElement);
          columnArray.forEach(function (element) {
            var headline = element.getAttribute("data-headline");

            if (headline) {
              var headlineElement = document.createElement("li");
              headlineElement.classList.add("hdlContinent");
              headlineElement.innerHTML = "<h1>" + headline + "</h1>";
              ulElement.appendChild(headlineElement);
            }

            var clonedElement = element.cloneNode(true);
            clonedElement.classList.add("countryItem");
            ulElement.appendChild(clonedElement); // add listeners

            clonedElement.addEventListener("mouseenter", function (e) {
              var continentId = e.target.getAttribute("data-continent");
              var continentElement = document.getElementById(continentId);
              continentElement.style.opacity = "1";
            });
            clonedElement.addEventListener("mouseleave", function (e) {
              var continentId = e.target.getAttribute("data-continent");
              var continentElement = document.getElementById(continentId);
              continentElement.style.opacity = "";
            });
          });
        });
      }
    };

    _this.state = {
      isLoaded: false,
      numColumns: 1
    };
    return _this;
  }

  WorldMap.prototype.componentDidMount = function () {
    var _this = this;

    utils_1.WindowEvents.addResizeCallback(this.updateSize);

    if (!WorldMap.contents) {
      fetch(this.props.url).then(function (response) {
        return response.text();
      }).then(function (result) {
        var tempDoc = document.createElement("div");
        tempDoc.innerHTML = result;
        WorldMap.contents = tempDoc.getElementsByClassName("content")[0].innerHTML;

        _this.setState({
          isLoaded: true
        });
      });
    }

    this.addEventListeners();
  };

  WorldMap.prototype.componentDidUpdate = function () {
    this.addEventListeners();
  };

  WorldMap.prototype.componentWillUnmount = function () {
    utils_1.WindowEvents.addResizeCallback(this.updateSize);
  };

  WorldMap.prototype.render = function () {
    var _this = this;

    return React.createElement("div", {
      ref: function ref(r) {
        return _this.element = r;
      },
      dangerouslySetInnerHTML: {
        __html: WorldMap.contents
      }
    });
  };

  WorldMap.contents = "";
  return WorldMap;
}(React.Component);

exports.WorldMap = WorldMap;